import bowser from 'bowser'
if(!bowser.check({msie: "11.0"})){
  alert('La versione del suo browser non è compatibile con il gestionale. La preghiamo di usare un browser diverso!')
  // ' + bowser.name + ' ' + bowser.version)
  window.location.href = "https://www.biomedia.net";
}

import Vue from 'vue'
import App from './App'
import router from './router'
import teras from './teras'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })

import axios from './axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

/*  
import soap from 'axios'

import VueSoap from 'vue-axios'
Vue.use(VueSoap, soap)

*/
/*  
var soap = axios.create()

if (process.env.NODE_ENV != 'development')
  soap.defaults.baseURL = 'http://biomedia.2dns.it:8080/j-bvent/services/'
soap.defaults.baseURL = 'http://tomcat:8080/j-bvent/services/'
soap.interceptors.response.use(function (response) {
  return JSON.parse(response.data.match(/<ns:return>(.*?)<\/ns:return>/g)[0].replace("<ns:return>", '').replace("</ns:return>", ''))
});

  /* 
soap.interceptors.response.use(function (response) {
  return JSON.parse(response.data.match(/<ns:return>(.*?)<\/ns:return>/g)[0].replace("<ns:return>", '').replace("</ns:return>", ''));
});

*/

import './css/layout.css'

import abs from './abs'

import langEn from './en'
teras.en = langEn
import langIt from './it'
import langIt136 from './it-136'
teras.it = langIt
teras.lang = teras[teras.language]

teras.browsername = bowser.name 
teras.browserversion = bowser.version

/*
import VueAnalytics from 'vue-analytics'
const googleAnalyticsId = 'UA-2826949-13'
Vue.use(VueAnalytics, { id: googleAnalyticsId, router: router, debug: true })
*/
/*
console.log("***********************************************************************************************************************************************************")
import aes from './aes'
var encrypted = aes.encode('SE FUNZIONA SONO UN FIGO')
console.log(encrypted)

//encrypted = '{"ct":"0q+lem+eYqPNmbEQJ0Q1b\/g42\/VxxWGI8NDVF4\/Q7XOa8uFDnKuUzXo1xZ6jizfs","iv":"f7bc694450f7082bccfbe52c691bcbd2","s":"6d3b3cae1fe501ec"}'
encrypted = '{"ct":"MULXdeCgZTHiKZO25q3MmA==","iv":"f1e164b5212410cc82e7617555d8bafe","s":"79b4ab1ce72ca4be"}';
var decrypted = aes.decode(encrypted)
console.log(decrypted)

console.log("***********************************************************************************************************************************************************")
*/
function goReady(url){
  router.replace(url)
  teras.appReady = true
}

var moment = require('moment')

router.onReady(()=>{
  console.log("ROUTE FIRST")
  axios.sessionGet('session_id').then((data) => {
    axios.sessionID = data.key
    console.log(sessionStorage.getItem('sessionID'))
    if(sessionStorage.getItem('sessionID')!='')
      sessionStorage.setItem('sessionID', data.key)
    console.log("ROUTE FIRST AFTER SESSION STARTED CON ID "+axios.sessionID)
    
    console.log(router.currentRoute)
    console.log(router.currentRoute.name)

    switch(router.currentRoute.name) {
        case 'home':
        case 'absNew':
        console.log("HOME: VERIFICO CHE ESISTE LA SESSION PER EVENTO e ABS") 
        axios.sessionGet('evento').then(function (data) {
          if('key' in data){
            teras.evento = data.key
            console.log("EVENTO READY "+teras.evento.id)
            teras.event.emit('eventoReady')
            if(moment(teras.evento.deadline).isAfter(moment())){
              axios.query('fetchOne','SELECT abstract FROM token LEFT JOIN abstract ON abstract.id=token.abstract WHERE abstract.id IS NOT NULL AND token.id= →token',{token:axios.sessionID}).then((data) =>  {
                console.log("+++++++++++++++++++++++++++++++++++++++++++++++TROVATO ABSTRACT N."+data.result)
                if(data.result == false){
                  abs.nuovo().then(() => {
                    goReady('/abs-new')
                    //router.replace('/abs-new')
                    //eras.appReady = true
                  })
                }else{
                  abs.load(data.result).then((data) => {
                    abs.lineeguida = true
                    axios.query('fetchAll','SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:teras.evento.id,abstract:abs.row.id},teras,'autori')
                    axios.query('fetchAll','SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:teras.evento.id,abstract:abs.row.id},teras,'affiliazioni').then(function (data) {
                      goReady('/abs-new')
                      //router.replace('/abs-new')
                      //teras.appReady = true
                    })
                  }) 
                }  
              })
            }else{
              teras.chiuso=true
              goReady('/')
              //router.replace('/')
              //teras.appReady = true
            }
          }else{
            teras.noevento=true
            goReady('/')
            //router.replace('/')
          }
        }) 
        break;
        
        case 'edit':
        console.log("EDIT: CARICO I DATI DI UN ABS SALVATO")      
        axios.query('fetchOne','SELECT id FROM abstract WHERE id = ←abstract AND premail= →premail',router.currentRoute.params).then((data) =>  {
          if(data.result == false){
            teras.noabstract=true
            goReady('/')
            //router.replace('/')
            //teras.appReady = true
          }else{
            console.log("TROVATO ABSTRACT N.")
            console.log(data)
            abs.load(data.result).then((data) => {
              axios.query('doQuery',"REPLACE INTO token VALUES (→id,←abstract)",{id:axios.sessionID,abstract:abs.row.id})
              abs.lineeguida = true
              axios.query('fetchAll','SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:abs.row.evento,abstract:abs.row.id},teras,'autori')
              axios.query('fetchAll','SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:abs.row.evento,abstract:abs.row.id},teras,'affiliazioni').then(function (data) {
                goReady('/abs-new')
                //router.replace('/abs-new')
                //teras.appReady = true
              })

              axios.query('fetchRow','SELECT * FROM evento WHERE id= →evento',{evento:abs.row.evento},teras,'evento').then(function (data) {
                axios.sessionSet('evento',data.result) 
                teras.event.emit('eventoReady')
              }) 
            }) 
          }
        })      
        break;
        
        case 'startnodeadline':
        case 'start':
        console.log("START: CARICO I DATI DI UN EVENTO e INVIO UN ABS NUOVO") 
        axios.query('fetchRow','SELECT * FROM evento WHERE id= →evento',router.currentRoute.params,teras,'evento').then(function (data) {
          axios.sessionSet('evento',data.result) 

          if(teras.evento.lingua==2){
            teras.language = 'en'
            teras.lang = teras[teras.language]
          }
          if(teras.evento.id==136){
            teras.it = langIt136
            teras.language = 'it'
            teras.lang = teras[teras.language]
          }
          if(router.currentRoute.name == 'startnodeadline'|| moment(teras.evento.deadline).isAfter(moment())){
            abs.nuovo().then(() => {
              goReady('/abs-new')
              //router.replace('/abs-new')
              //teras.appReady = true
            })
          }else{
            teras.chiuso=true
            goReady('/')
            //router.replace('/')
            //teras.appReady = true
          }
          teras.event.emit('eventoReady')

        })     
        break;

        case 'startconsulta':
        console.log("START CONSULTA: CARICO I DATI DI UN EVENTO e INVIO ALL'INSERIMENTO DEL CODICE") 
        axios.query('fetchRow','SELECT * FROM evento WHERE id= →evento',router.currentRoute.params,teras,'evento').then(function (data) {
          axios.sessionSet('evento',data.result)
          goReady('/consulta')         
          teras.event.emit('eventoReady')
        }) 
        break;

        case 'consulta':
        console.log("CONSULTA: CARICO I DATI DI UN EVENTO e INVIO ALL'INSERIMENTO DEL CODICE") 
        axios.sessionGet('evento').then(function (data) {
          if('key' in data){
            teras.evento = data.key
            goReady('/consulta')
            teras.event.emit('eventoReady')
          }else{
            teras.noevento=true
            goReady('/')
          }
        })  
        break;

        default:
        console.log("HOME: VERIFICO CHE ESISTE LA SESSION PER EVENTO e ABS")
        axios.sessionGet('evento').then(function (data) {
          if('key' in data){
            teras.evento = data.key
            console.log("EVENTO READY")
            teras.event.emit('eventoReady')
            if(moment(teras.evento.deadline).isAfter(moment())){
              abs.nuovo().then(() => {
                goReady('/abs-new')
                //router.replace('/abs-new')
                //teras.appReady = true
              })
            }else{
              teras.chiuso=true
              goReady('/')
              //router.replace('/')
              //teras.appReady = true
            }
          }else{
            teras.noevento=true
            goReady('/')
            //router.replace('/')
          }
        }) 
    }
  })
})

teras.event.on('eventoReady',function(){
  axios.query('fetchRow','SELECT * FROM bm_bvent.evento WHERE id= →bvent',{bvent:teras.evento.bvent},teras,'bvent')
  axios.query('fetchAll',"SELECT id,CONCAT(sigla,' ',nome) AS nome_it,CONCAT(sigla,' ',nome) AS nome_en FROM bm_bvent.associazione WHERE FIND_IN_SET(id, →associazioni) ORDER BY sigla,nome",{associazioni:teras.evento.paassociazione},teras,'associazioni')
  axios.query('fetchAll','SELECT * FROM topic WHERE evento= →evento AND FIND_IN_SET(1,tipo) ORDER BY peso,nome',{evento:teras.evento.id},teras,'topicposter')
  axios.query('fetchAll','SELECT * FROM topic WHERE evento= →evento AND FIND_IN_SET(2,tipo) ORDER BY peso,nome',{evento:teras.evento.id},teras,'topiccomunicazione')
  axios.query('fetchAll','SELECT id, nome AS nome_it, nomeeng AS nome_en FROM bm_bvent.categoria ORDER BY nome',{},teras,'categoriaprofessionale')
  axios.query('fetchAll',`SELECT 99 as id,'ESTERO' as nome_it,'ESTERO' AS nome_en UNION ALL (SELECT id, nome AS nome_it, nome AS nome_en FROM options.regione ORDER BY nome ) `,{},teras,'regione')
  axios.query('fetchAll','SELECT iso3 AS id, nome AS nome_it, nomeeng AS nome_en FROM codicefiscale.nazione ORDER BY peso,nome',{},teras,'nazione')
})

/*
var tolink = (router.mode=='hash') ? document.location.hash.replace("#", "") : document.location.pathname.replace("/bams", "")
var tolinkparams = (typeof router.resolve(tolink).route.params != undefined) ? router.resolve(tolink).route.params : {}
console.log(tolink)
*/



//router.push('/no-event')
/*
if ('evento' in tolinkparams){
  axios.query('fetchRow','SELECT * FROM evento WHERE id= →evento',{evento:tolinkparams.evento},teras,'evento').then(function (data) {
    axios.sessionSet('evento',data.result) 
    teras.event.emit('eventoReady')
  })
}else{
  axios.sessionGet('evento').then(function (data) {
    if('key' in data){
      teras.evento = data.key
      teras.event.emit('eventoReady')
    }else{
      teras.event.emit('eventoNotset')
      //$notify.error({title: 'Errore',message: 'Nessun evento selezionato!'});
    }
  })
}
*/

/*
teras.event.on('abstractReady',function(id){
  console.log(axios.sessionID+"###############################ABSTRACT "+id)
  console.log(abs)
  if(id!=''){
    //abs.loadEncode(id).then((data) => {
    abs.load(id).then((data) => {
      axios.query('doQuery',"REPLACE INTO token VALUES (→id,←abstract)",{id:axios.sessionID,abstract:id})
      abs.lineeguida = true
      axios.query('fetchAll','SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:teras.evento.id,abstract:abs.row.id},teras,'autori')
      axios.query('fetchAll','SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero',{evento:teras.evento.id,abstract:abs.row.id},teras,'affiliazioni').then(function (data) {
        router.push('/abs-new')
        teras.appReady = true
        abs.codice()
      })
    })
  }else{
    abs.nuovo().then(() => {
      if(moment(teras.evento.deadline).isAfter(moment())){
        router.push('/abs-new')
      }else{
        teras.chiuso=true
        router.push('/')
      }
      teras.appReady = true
    })
      
  }

})
*/



/*
axios.sessionGet('utente').then(function (data) {

  axios.query('fetchAll','SELECT * FROM outinvoce ORDER BY outin,nome',{},teras,'evento')
  axios.query('fetchAll','SELECT * FROM outinvocemore ORDER BY outinvoce,nome',{},teras,'bvent')

    teras.appReady = true
})
*/

/*
teras.event.on('setup', function(params) {
  teras.appReady = false
  console.log("SETUP con params")
  console.log(params)
  var parentTeras = teras
  var parentRouter = router
  axios.get('api/vue/setup/',{params:params})
    .then(function (response) {
      var api = response.data
      parentTeras.evento = api.data.evento
      parentTeras.bvent = api.data.bvent
      parentTeras.topicposter = api.data.topicposter
      parentTeras.topiccomunicazione = api.data.topiccomunicazione
      parentTeras.categoriaprofessionale = api.data.categoriaprofessionale
      parentTeras.nazione = api.data.nazione
      parentTeras.regione = api.data.regione
      parentTeras.associazioni = api.data.associazioni



      parentTeras.affiliazioni = api.data.affiliazioni
      parentTeras.autori = api.data.autori
      parentTeras.abs = api.data.abs
      if(parentTeras.evento.poster==2)
        parentTeras.abs.poster=1
      if(parentTeras.evento.comunicazione==2)
        parentTeras.abs.comunicazione=1
      parentTeras.abs.preview = 0
      //parentTeras.abs.lineeguida = true
      console.log(api.data.abs)
      console.log(parentTeras.abs) 
          

      document.title = parentTeras.bvent.titolo
      parentRouter.push('/abs-new')
      parentTeras.appReady = true
    })
    .catch(function (error) {
      console.log("ERROR AL SETUP_______________________________________________________________________________________________________---")
      console.log(error)
      parentRouter.push('/noevent')
    })
})
console.log( document.location)
var tolink = (router.mode=='hash') ? document.location.hash.replace("#", "") : document.location.pathname.replace("/bams", "")
console.log(tolink)
var tolinkparams = (typeof router.resolve(tolink).route.params != undefined) ? router.resolve(tolink).route.params : {}

teras.event.emit('setup',tolinkparams)
*/

Vue.prototype.$teras = teras
Vue.prototype.$abs = abs
new Vue({
  el: '#app',
  router,
  //soap,
  data:{
    teras,
    abs
  },
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js